﻿let $ = require('jquery');

$('.jnf-widget.jnf-widget-mobile-menu').each(function (menuIndex, menuElement) {
	let $menu = $(menuElement);

	let onCloseClick = function () {
		$menu.trigger('mobileMenuClose');
	};

	$menu.find('.jnf-widget-menu-1-menu-mobile-window-close').on('click', onCloseClick);
});

$('.jnf-widget.jnf-widget-mobile-menu').each(function (menuIndex, menuElement) {
	let $menu = $(menuElement);
	let $window = $(window);
	let openClass = 'jnf-widget-mobile-menu-visible';

	let onMobileMenuOpen = function () {
		$menu.addClass(openClass);
	};

	let onMobileMenuClose = function () {
		$menu.removeClass(openClass);
	};

	$window.on('mobileMenuOpen', onMobileMenuOpen);
	$window.on('mobileMenuClose', onMobileMenuClose);
});